var React = require('react');

function WhiteArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Line 9 Copy 2"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square","key":1},React.createElement("polyline",{"id":"Line-9-Copy-2","stroke":"#FFFFFF","strokeWidth":"3","points":"3 23 13 13 3 3"}))]);
}

WhiteArrowRight.defaultProps = {"width":"16px","height":"26px","viewBox":"0 0 16 26","version":"1.1"};

module.exports = WhiteArrowRight;

WhiteArrowRight.default = WhiteArrowRight;
